<template>
  <FiltersItemContent
    v-if="uniqueWaittimeLength > 0"
  >
    <template #content>
      <div
        id="filter-slider-box-min-max-waiting"
        class="filtersSlider"
      >
        <h5 class="filtersSlider__title">
          <span>{{ $l('showresult.filter.waitingTime') }}</span>
        </h5>
        <div class="filtersSlider__value">
          <span id="slider-traveltime-text">{{ getSliderHeaderText }}</span>
        </div>
        <div class="sliderWrapper sliderWrapper--filter">
          <BaseSlider
            id="minMax-traveltime-slider"
            v-model:modelValue="sliderValues"
            :config="sliderConfig"
            @update="sliderUpdateEvent"
          />
        </div>
      </div>
    </template>
  </FiltersItemContent>
</template>


<script setup>
import { getTimeText, l } from '@js/utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

defineEmits(['update:filterObject']);

const uniqueWaittimeLength = computed(() => resultQueryStore.state.response.uniqueWaittime.length - 1);

const sliderValuesTranslated = ref([
	0,
	resultQueryStore.state.response.uniqueWaittime[uniqueWaittimeLength.value]
]);

const sliderConfig = computed(() => ({
	connect: [false, true, false],
	tooltips: [false, false],
	range: {
		min: [0],
		max: [uniqueWaittimeLength.value]
	},
	handleAttributes: [
		{ 'aria-label': `Min ${l('showresult.filter.waitingTime')}` },
		{ 'aria-label': `Max ${l('showresult.filter.waitingTime')}` }
	]
}));

const sliderValues = computed({
	get: () => {
		const selected = [0, uniqueWaittimeLength.value];
		if (filtersStore.state?.airportWaitTime?.length) {
			const selected1 = filtersStore.state.airportWaitTime[0];
			const selected2 = filtersStore.state.airportWaitTime[1];
			selected[0] = resultQueryStore.state.response.uniqueWaittime.findIndex(time => time >= selected1) || 0;
			selected[1] = resultQueryStore.state.response.uniqueWaittime.findIndex(time => time >= selected2) || uniqueWaittimeLength.value;
		}
		return selected;
	},
	set: (values) => {
		const [start, end] = values;
		if (start === 0 && end === uniqueWaittimeLength.value) {
			filtersStore.set({ key: 'airportWaitTime', value: null });
			return;
		}
		sliderUpdateEvent(values);
		filtersStore.set({ key: 'airportWaitTime', value: sliderValuesTranslated.value });
	}
});

const getSliderHeaderText = computed(() => `${getTimeText(sliderValuesTranslated.value[0])} - ${getTimeText(sliderValuesTranslated.value[1])}`);

const sliderUpdateEvent = (sliderValues) => {
	const [start, end] = sliderValues;
	sliderValuesTranslated.value = [
		resultQueryStore.state.response.uniqueWaittime[start],
		resultQueryStore.state.response.uniqueWaittime[end]
	];
};
</script>
